import { RefObject, useRef } from 'react';
import styled from 'styled-components';
import {
  useTradeTapeFetchData,
  useTradeTapeIdsList,
  useTradeTapeService,
} from '@paradigm/features/src/unified-rfqs/contexts/unified-trade-tapes';
import { Order } from '@paradigm/features/src/unified-rfqs/entities/shared';
import BottomTabFilter from '#/components/UnifiedRfqs/BottomPanelFilter';
import BaseTable from '#/components/UnifiedRfqs/components/BaseTable';
import TradeRow, {
  TradeHeaderRow,
} from '#/components/UnifiedRfqs/trade-tape/TradeRow';
import ActionsBar from '#/components/UnifiedRfqs/components/bottom-tabs/ActionsBar';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export default function TradeTapeContent() {
  const { status, canFetchMore } = useTradeTapeFetchData();
  const { fetcher } = useTradeTapeService();
  const scrollableRef = useRef<HTMLDivElement>(null);

  const tradesIds = useTradeTapeIdsList();
  const isEmpty = tradesIds.length === 0;
  return (
    <Container>
      <StyledActionsBar>
        <BottomTabFilter />
      </StyledActionsBar>
      <BaseTable
        status={status}
        fetcher={fetcher}
        canFetchMore={canFetchMore && !isEmpty}
        isEmpty={isEmpty}
        entityRowsList={
          <TradesList tradesIds={tradesIds} scrollableRef={scrollableRef} />
        }
        headerRow={<TradeHeaderRow />}
        dataTestId="unified-rfq-trade-tape-table"
        scrollableRef={scrollableRef}
        emptyListMessage="No trades happened today"
      />
    </Container>
  );
}

const Container = styled.div`
  flex: 1; // take 100% heigh
  display: flex;
  flex-direction: column;
`;

function TradesList(props: {
  tradesIds: readonly Order['id'][];
  scrollableRef: RefObject<HTMLDivElement>;
}) {
  return (
    <>
      {props.tradesIds.map((id) => (
        <TradeRow key={id} tradeId={id} scrollableRef={props.scrollableRef} />
      ))}
    </>
  );
}

const StyledActionsBar = styled(ActionsBar)`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 1rem;
    height: unset;
  }
`;
